/* Candela product cards — Ronning-style reveal for cards below the first screen.
   Loaded by sections/candela-collection-grid.liquid and
   sections/candela-related-products.liquid.
   - A .candela-card--fade card fades and rises in once it has scrolled into
     view and its main image has loaded, so the motion is always seen. On a
     slow image it goes after MAX_WAIT anyway and the image fades in on its
     own when it arrives (is-loaded), so a fast scroll never shows white.
   - Cards that arrive in the same frame cascade left to right by column.
   - Lazy images are switched to eager two viewports ahead, so Safari loads
     as far ahead as Chrome and the image is ready before the card is in view.
   Re-runs for cards added by infinite scroll (candela:cards-added), for
   recommendations Dawn's <product-recommendations> swaps in after load, and
   theme-editor section reloads (shopify:section:load). */

(function () {
  if (window.candelaCardReveal) return;
  window.candelaCardReveal = true;

  var STAGGER = 0.09;
  var MAX_WAIT = 350;
  var CARD = '.candela-card--fade';
  var IMG = '.candela-card__img--main';

  function columnDelay(card) {
    var item = card.parentElement && card.parentElement.tagName === 'LI' ? card.parentElement : card;
    var grid = item.parentElement;
    if (!grid) return 0;
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1;
    var index = Array.prototype.indexOf.call(grid.children, item);
    return (index % cols) * STAGGER;
  }

  function reveal(card, force) {
    if (card.classList.contains('is-revealed')) return;
    if (!card._candelaInView) return;
    if (!card._candelaReady && !force) return;
    card.style.setProperty('--reveal-delay', columnDelay(card) + 's');
    card.classList.add('is-revealed');
    if (inView) inView.unobserve(card);
  }

  function markReady(card) {
    card._candelaReady = true;
    reveal(card);
  }

  var inView = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var card = entry.target;
          card._candelaInView = true;
          reveal(card);
          setTimeout(function () { reveal(card, true); }, MAX_WAIT);
        });
      }, { rootMargin: '0px 0px -4% 0px' })
    : null;

  var lookahead = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.loading = 'eager';
          lookahead.unobserve(entry.target);
        });
      }, { rootMargin: '200% 0px' })
    : null;

  function onImage(e) {
    var img = e.target;
    if (!img.matches || !img.matches(CARD + ' ' + IMG)) return;
    img.classList.add('is-loaded');
    markReady(img.closest(CARD));
  }

  document.addEventListener('load', onImage, true);
  document.addEventListener('error', onImage, true);

  function init(root) {
    (root || document).querySelectorAll(CARD + ':not(.is-revealed)').forEach(function (card) {
      if (!inView) card._candelaInView = true;
      else inView.observe(card);

      var img = card.querySelector(IMG);
      if (!img || (img.complete && img.naturalWidth > 0)) {
        if (img) img.classList.add('is-loaded');
        markReady(card);
      } else if (lookahead && img.loading === 'lazy') {
        lookahead.observe(img);
      }
    });
  }

  function watchRecommendations(root) {
    if (!('MutationObserver' in window)) return;
    (root || document).querySelectorAll('product-recommendations').forEach(function (el) {
      new MutationObserver(function () { init(el); }).observe(el, { childList: true });
    });
  }

  function start() {
    init();
    watchRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('candela:cards-added', function (e) { init(e.target); });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    watchRecommendations(e.target);
  });
})();
